import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import * as PermissionsConstants from "../../const/constants";
import { ReactComponent as ReceiptIcon } from "../../assets/svg/receipt.svg";
import { ReactComponent as ShippmentIcon } from "../../assets/svg/shippment.svg";
import { ReactComponent as AdjustmentIcon } from "../../assets/svg/adjustment.svg";
import TransactionHistorySearchForm from "./HistorySearchForm";
import axios from "axios";
import data from "../../assets/apiRoutes.json";
import { useHistory } from "react-router-dom";
import DxTabPanel, { Item } from "devextreme-react/tab-panel";

const History = (props) => {
  const history = useHistory();
  const [value, setValue] = useState(0);
  const [filteredTabs, setFilteredTabs] = useState([]);
  const [selectedTabIndex, _setSelectedTabIndex] = useState(() => {
    const saved = sessionStorage.getItem('wm_history_selectedTabIndex');
    return saved !== null ? parseInt(saved, 10) : 0;
  });
  const setSelectedTabIndex = useCallback((val) => {
    _setSelectedTabIndex(val);
    sessionStorage.setItem('wm_history_selectedTabIndex', val);
  }, []);
  const onTabSelectionChanged = useCallback((e) => {
    if (e.fullName === 'selectedIndex') {
      setSelectedTabIndex(e.value);
      history.push("/wm/history");
    }
  }, []);
  const onRedirectListingPage = () => {
    history.push("/wm/history");
  };
  const handleTabs = (e, val) => {
    setValue(val);
  };

  function TabPanel(props) {
    const { children, value, index } = props;
    return value === index && <div>{children}</div>;
  }
  const fetchRolePermissions = () => {
    axios
      .get(
        `${window._env_.REACT_APP_AUTH_URL}/${data.idp.GetPermissionsByRole}?roleName=${props.oidc.user.profile.role}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${props.oidc.user.access_token}`
          }
        }
      )
      .then((res) => {
        let tabs = [];
        for (let key in res.data) {
          TransactionTabs.map((link) => {
            let arrValues = res.data[key];
            if (arrValues.length > 0) {
              if (arrValues.includes(link.permission) && tabs.indexOf(link) < 0) {
                tabs.push(link);
              }
            }
          });
        }
        setFilteredTabs(tabs);
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  useEffect(() => {
    fetchRolePermissions();
  }, []);
  useEffect(() => {
    if (filteredTabs.length > 0 && selectedTabIndex >= filteredTabs.length) {
      setSelectedTabIndex(0);
    }
  }, [filteredTabs]);
  var TransactionTabs = [
    {
      id: 1,
      label: "Receipt",
      icon: ReceiptIcon,
      permission: PermissionsConstants.HistoryReadReceipts,
      component: TransactionHistorySearchForm,
    },
    {
      id: 2,
      label: "Shipment",
      icon: ShippmentIcon,
      permission: PermissionsConstants.HistoryReadShipments,
      component: TransactionHistorySearchForm,
    },
    {
      id: 3,
      label: "Adjustment",
      icon: AdjustmentIcon,
      permission: PermissionsConstants.HistoryReadAdjustments,
      component: TransactionHistorySearchForm,
    },
  ];
  return (
    <div>
      <DxTabPanel key={selectedTabIndex} onOptionChanged={onTabSelectionChanged} selectedIndex={selectedTabIndex}>
        {filteredTabs.map((m, i) => (
          <Item key={i} title={m.label}>
            <TransactionHistorySearchForm permission={m.permission} />
          </Item>
        ))}
      </DxTabPanel>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(History);
